import { useState } from "react";
import { HeroSection } from "../components/landing/HeroSection";
import { ProofSection } from "../components/landing/ProofSection";
import { DashboardMockSection } from "../components/landing/DashboardMockSection";
import { MeetNovaSection } from "../components/landing/MeetNovaSection";

export default function Landing() {
  const [demoTrigger, setDemoTrigger] = useState(0);

  return (
    <div className="bg-kaizen-bg text-kaizen-text font-sans overflow-x-hidden" data-testid="landing-page">
      <HeroSection onSeeAdapt={() => setDemoTrigger((n) => n + 1)} />
      <ProofSection trigger={demoTrigger} />
      <DashboardMockSection />
      <MeetNovaSection />
      <footer className="text-center py-10 text-xs text-kaizen-dim2">Kaizen · small beats zero</footer>
    </div>
  );
}
